<script lang="ts">
    import { _ } from "svelte-i18n";
    import type { AlertManager } from "./AlertManager";

    export let manager: AlertManager;
    const alertState = manager.getAlertStateStore();

    let timeout: NodeJS.Timeout;

    $: {
        if (typeof timeout !== "undefined") {
            clearTimeout(timeout);
        }
        if ($alertState.autoClose > 0) {
            timeout = setTimeout(() => {
                $alertState = { open: false };
            }, $alertState.autoClose);
        }
    }
</script>

{#if $alertState.open}
    <div class="full-screen-alert d-flex align-items-center" role="alert">
        <div class="container text-center">
            <div class="row justify-content-center">
                <div class="col-4 alert alert-{$alertState.type ?? "secondary"}">
                    <h3>
                        {#if typeof $alertState.icon !== "undefined"}
                            <i
                                class="border-0 bg-transparent fe fe-{$alertState.icon} me-2"
                            ></i>
                        {/if}
                        {$_($alertState.messageKey)}
                    </h3>
                </div>
            </div>
        </div>
    </div>
{/if}

<style>
    .full-screen-alert {
        background-color: #8b8b8b73;
    }
</style>
